import { addProp } from "@pnp/odata";
import { _List } from "../lists/types.js";
import { Items } from "./types.js";
addProp(_List, "items", Items);
//# sourceMappingURL=list.js.map